var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./address-form/country.j2"] = require( "./address-form/country.j2" );
dependencies["./address-form/address-form-group1.j2"] = require( "./address-form/address-form-group1.j2" );
dependencies["./address-form/address-form-group2.j2"] = require( "./address-form/address-form-group2.j2" );
dependencies["./address-form/address-form-group3.j2"] = require( "./address-form/address-form-group3.j2" );
dependencies["./address-form/address-form-group4.j2"] = require( "./address-form/address-form-group4.j2" );
dependencies["./address-form/address-form-group5.j2"] = require( "./address-form/address-form-group5.j2" );
dependencies["./address-form/address-form-group6.j2"] = require( "./address-form/address-form-group6.j2" );
dependencies["./address-form/address-form-group7.j2"] = require( "./address-form/address-form-group7.j2" );
dependencies["./address-form/address-form-group8.j2"] = require( "./address-form/address-form-group8.j2" );
dependencies["./address-form/address-nickname.j2"] = require( "./address-form/address-nickname.j2" );
dependencies["./address-form/default-address.j2"] = require( "./address-form/default-address.j2" );
dependencies["./errors.j2"] = require( "./errors.j2" );
dependencies["./address-form/buttons.j2"] = require( "./address-form/buttons.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/address-form.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
output += "\n\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"showErrors") && (runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"errors")),"location") == "js-address-edit-form" || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"errors")),"location") == "payment-and-address")) {
output += "\n\n    <form novalidate class=\"js-address-edit-form js-account-errors\" autocomplete=\"off\" name=\"js-address-edit-form\">\n\n";
;
}
else {
output += "\n\n    <form novalidate class=\"js-address-edit-form\" autocomplete=\"off\" name=\"js-address-edit-form\">\n\n";
;
}
output += "\n\n        <input autocomplete=\"false\" name=\"hidden\" type=\"text\" class=\"u-extra-small--hide\">\n\n        <div class=\"o-row\">\n\n            <div class=\"g-address-payment__required ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"editAddress")?"g-address-payment--edit":""), env.opts.autoescape);
output += "\">\n\n                <p class=\"c-form__required-instructions\">\n                    ";
output += runtime.suppressValue((lineno = 30, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account-fieldRequired",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n                </p>\n\n            </div>\n\n        </div>\n\n\n        <div class=\"o-row\">\n\n            <div class=\"g-address-payment__country ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"editAddress")?"g-address-payment--edit":""), env.opts.autoescape);
output += "\">\n\n                ";
env.getTemplate("./address-form/country.j2", false, "account/templates/partials/address-form.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n            </div>\n\n        </div>";
if((lineno = 48, colno = 23, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"])) && runtime.memberLookup(((lineno = 48, colno = 47, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address") && runtime.memberLookup((runtime.memberLookup(((lineno = 48, colno = 79, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address")),"groupType")) {
var t_5;
t_5 = runtime.memberLookup((runtime.memberLookup(((lineno = 50, colno = 47, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address")),"groupType");
frame.set("currentGroupType", t_5, true);
if(frame.topLevel) {
context.setVariable("currentGroupType", t_5);
}
if(frame.topLevel) {
context.addExport("currentGroupType", t_5);
}
;
}
else {
var t_6;
t_6 = runtime.contextOrFrameLookup(context, frame, "groupType");
frame.set("currentGroupType", t_6, true);
if(frame.topLevel) {
context.setVariable("currentGroupType", t_6);
}
if(frame.topLevel) {
context.addExport("currentGroupType", t_6);
}
;
}
output += "\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group1" || runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "fpgroup1") {
output += "\n\n            ";
env.getTemplate("./address-form/address-form-group1.j2", false, "account/templates/partials/address-form.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "\n\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group2" || runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "fpgroup2") {
output += "\n\n            ";
env.getTemplate("./address-form/address-form-group2.j2", false, "account/templates/partials/address-form.j2", null, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
t_11.render(context.getVariables(), frame, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
output += t_12
output += "\n\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group3" || runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "fpgroup3") {
output += "\n\n            ";
env.getTemplate("./address-form/address-form-group3.j2", false, "account/templates/partials/address-form.j2", null, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
t_15.render(context.getVariables(), frame, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
output += t_16
output += "\n\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group4" || runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "fpgroup4") {
output += "\n\n            ";
env.getTemplate("./address-form/address-form-group4.j2", false, "account/templates/partials/address-form.j2", null, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
t_19.render(context.getVariables(), frame, function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
output += t_20
output += "\n\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group5" || runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "fpgroup5") {
output += "\n\n            ";
env.getTemplate("./address-form/address-form-group5.j2", false, "account/templates/partials/address-form.j2", null, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
t_23.render(context.getVariables(), frame, function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
output += t_24
output += "\n\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group6" || runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "fpgroup6") {
output += "\n\n            ";
env.getTemplate("./address-form/address-form-group6.j2", false, "account/templates/partials/address-form.j2", null, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
t_27.render(context.getVariables(), frame, function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
output += t_28
output += "\n\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group7" || runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "fpgroup7") {
output += "\n\n            ";
env.getTemplate("./address-form/address-form-group7.j2", false, "account/templates/partials/address-form.j2", null, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
t_31.render(context.getVariables(), frame, function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
output += t_32
output += "\n\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group8" || runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "fpgroup8") {
output += "\n\n            ";
env.getTemplate("./address-form/address-form-group8.j2", false, "account/templates/partials/address-form.j2", null, function(t_37,t_35) {
if(t_37) { cb(t_37); return; }
t_35.render(context.getVariables(), frame, function(t_38,t_36) {
if(t_38) { cb(t_38); return; }
output += t_36
output += "\n\n        ";
})});
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
output += "\n\n\n        <div class=\"o-row\">\n\n            <div class=\"g-address-payment__nickname ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"editAddress")?"g-address-payment--edit":""), env.opts.autoescape);
output += "\">\n\n                ";
env.getTemplate("./address-form/address-nickname.j2", false, "account/templates/partials/address-form.j2", null, function(t_41,t_39) {
if(t_41) { cb(t_41); return; }
t_39.render(context.getVariables(), frame, function(t_42,t_40) {
if(t_42) { cb(t_42); return; }
output += t_40
output += "\n\n            </div>\n\n        </div>\n\n        <div class=\"o-row\">\n\n            ";
output += "\n            ";
output += "\n\n        </div>\n\n        <div class=\"o-row c-adjacent-row\">\n\n            <div class=\"g-address-payment__default-address ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"editAddress")?"g-address-payment--edit":""), env.opts.autoescape);
output += "\">\n\n                ";
env.getTemplate("./address-form/default-address.j2", false, "account/templates/partials/address-form.j2", null, function(t_45,t_43) {
if(t_45) { cb(t_45); return; }
t_43.render(context.getVariables(), frame, function(t_46,t_44) {
if(t_46) { cb(t_46); return; }
output += t_44
output += "\n\n            </div>\n\n        </div>\n\n        ";
var t_47;
t_47 = "js-address-edit-form";
frame.set("location", t_47, true);
if(frame.topLevel) {
context.setVariable("location", t_47);
}
if(frame.topLevel) {
context.addExport("location", t_47);
}
output += "\n\n\n        <div class=\"o-row\">\n\n            ";
env.getTemplate("./errors.j2", false, "account/templates/partials/address-form.j2", null, function(t_50,t_48) {
if(t_50) { cb(t_50); return; }
t_48.render(context.getVariables(), frame, function(t_51,t_49) {
if(t_51) { cb(t_51); return; }
output += t_49
output += "\n\n        </div>\n\n        <div class=\"o-row\">\n\n            ";
env.getTemplate("./address-form/buttons.j2", false, "account/templates/partials/address-form.j2", null, function(t_54,t_52) {
if(t_54) { cb(t_54); return; }
t_52.render(context.getVariables(), frame, function(t_55,t_53) {
if(t_55) { cb(t_55); return; }
output += t_53
output += "\n\n        </div>\n\n    </form>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/address-form.j2"] , dependencies)